import { useMemo } from 'react';

import { Document, LinkAttachment } from 'models/document';

interface GroupedDocuments {
  studyGuideDocuments: Document[];
  slideDocuments: Document[];
}

interface GroupedLinkAttachments {
  studyGuideLinkAttachments: LinkAttachment[];
  slideLinkAttachments: LinkAttachment[];
}

const useAttachmentGroups = (
  documents: Document[],
  linkAttachments: LinkAttachment[],
) => {
  const groupedDocuments = useMemo<GroupedDocuments>(() => {
    const result: GroupedDocuments = {
      studyGuideDocuments: [],
      slideDocuments: [],
    };
    for (const doc of documents) {
      if (doc.attachment_type === 'slide') {
        result.slideDocuments.push(doc);
      } else {
        result.studyGuideDocuments.push(doc);
      }
    }
    return result;
  }, [documents]);

  const groupedLinkAttachments = useMemo<GroupedLinkAttachments>(() => {
    const result: GroupedLinkAttachments = {
      studyGuideLinkAttachments: [],
      slideLinkAttachments: [],
    };
    for (const link of linkAttachments) {
      if (link.attachment_type === 'slide') {
        result.slideLinkAttachments.push(link);
      } else {
        result.studyGuideLinkAttachments.push(link);
      }
    }
    return result;
  }, [linkAttachments]);

  return {
    ...groupedDocuments,
    ...groupedLinkAttachments,
  };
};

export default useAttachmentGroups;
